import React from 'react';

// Cronologia dell'asta e annullamento dell'ultima assegnazione.
//
// Prima l'unico rimedio a un prezzo sbagliato era rimuovere il giocatore dalla
// rosa: il credito tornava, ma il turno e la fase restavano sfasati. E in
// un'asta fra amici le contestazioni sono la norma, quindi avere un registro
// leggibile risolve le discussioni.

function formatTime(ms) {
    const date = new Date(ms);
    return date.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
}

export default function AuctionLog({ log, canUndo, onUndo }) {
    const entries = [...(log ?? [])].reverse();

    return (
        <div className="panel">
            <div className="panel-header">
                <h3 className="panel-title">Cronologia</h3>
                {canUndo && (
                    <button type="button" className="btn btn--ghost btn--sm" onClick={onUndo}>
                        Annulla ultima assegnazione
                    </button>
                )}
            </div>
            <div className="panel-body">
                <div className="log">
                    {entries.length === 0 && (
                        <div className="log-empty">Ancora nessun evento.</div>
                    )}
                    {entries.map((entry, index) => (
                        <div key={`${entry.seq}-${index}`} className="log-entry">
                            <span className="log-time">{formatTime(entry.at_ms)}</span>
                            <span className="log-text">{entry.message}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
